import * as React from "react";
import { ModalFooter as RBModalFooter, ModalFooterProps } from "react-bootstrap";

interface IModalFooterProps extends ModalFooterProps {}

export const ModalFooter: React.FC<IModalFooterProps> = (props: IModalFooterProps) => {
    const { children } = props;
    return <RBModalFooter>{children}</RBModalFooter>;
};
